import { combineReducers } from 'redux';

import salesList from './sales/_reducers';

const salesListings = combineReducers({
  salesListings: salesList
});

export default salesListings;
